export class Countries {
  constructor() {
    this.countries = [];
  }

  countries: Array<Country>;
}

export class Country {
  constructor() {
    this.countryId = '';
    this.countryName = '';
  }

  countryId: string;
  countryName: string;
}
